import he from 'he';

const recentlyViewed = function () {

	const maxItems = 4

	function get() {
		return JSON.parse(localStorage.getItem("recentlyViewed"))
	}

	function add(obj) {
		let recents = get()
		// only add a product to recents if its NOT already in there..
		if (recents.findIndex(recent => recent.id == obj.id) === - 1) {
			// console.log('adding product to recently viewed', obj)
			recents.unshift(obj)
			if (recents.length > maxItems) recents.pop()
			localStorage.setItem("recentlyViewed", JSON.stringify(recents));
		}
	}

	function init() {
		// get recently viewed items
		if (localStorage.getItem("recentlyViewed") === null) {
			localStorage.setItem("recentlyViewed", JSON.stringify([]));
			window.recentlyViewed = []
		} else {
			window.recentlyViewed = get()
		}

		// if we're looking at a product, add it to recently 
		// viewed localstorage for next page load
		if (typeof window.simpleProduct !== "undefined") {
			// const cleanProduct = window.simpleProduct.replace(/(\r\n|\n|\r)/gm, "");
			// let product = JSON.parse(he.decode(cleanProduct))
			// let slimProduct = {}
			// slimProduct.id = product.id
			// slimProduct.title = product.title
			// slimProduct.handle = product.handle
			// slimProduct.featured_image = product.featured_image
			// slimProduct.price = product.price
			add(window.simpleProduct);
		}
	}

	return init()
}

export default recentlyViewed
